import {
    ArchiveStatus,
} from 'app/enums/common.enums'

const injectArchived = (archived: boolean) => {
    return (cb) => {
        return (params) => {
            return cb({
                ...params,
                archived,
                archiveStatus: archived ? ArchiveStatus.ARCHIVED : ArchiveStatus.ACTIVE,
            })
        }
    }
}

export default injectArchived
